/* OLEEYA mobile autocomplete using Shopify locale-aware Predictive Search API. */
(function(){
  function init(){
    const area=document.querySelector('.oleeya-mobile-search-area');
    if(!area || area.dataset.oleeyaReady==='1')return;
    const input=area.querySelector('#oleeya-mobile-search-input');
    const popup=area.querySelector('#oleeya-mobile-search-suggestions');
    const form=area.querySelector('form');
    if(!input || !popup || !form)return;
    area.dataset.oleeyaReady='1';
    let timer=null, active=null, counter=0;
    const element=(tag,cls,value)=>{
      const e=document.createElement(tag);
      if(cls)e.className=cls;
      if(value!==undefined)e.textContent=value;
      return e;
    };
    const hide=()=>{popup.hidden=true;input.setAttribute('aria-expanded','false')};
    const show=()=>{popup.hidden=false;input.setAttribute('aria-expanded','true')};
    const resultsUrl=term=>{
      const u=new URL(form.action,location.origin);
      u.searchParams.set('q',term);
      u.searchParams.set('type','product');
      return u.toString();
    };
    const heading=t=>popup.appendChild(element('div','oleeya-predictive-heading',t));
    const row=(text,url)=>{
      const a=element('a','oleeya-predictive-row',text);
      a.href=url;return a;
    };
    const imgFor=p=>{
      const pic=p.featured_image||p.featured_media||p.image;
      let url=typeof pic==='string'?pic:(pic&&(pic.url||pic.src||pic.preview_image?.src));
      if(!url)return null;
      try{url=new URL(url,location.origin).href}catch(e){return null}
      const img=element('img','oleeya-predictive-product-img');
      img.src=url;img.alt='';img.loading='lazy';return img;
    };
    function priceFor(p){
      if(p.price==null)return '';
      const str=String(p.price);
      if(!str)return '';
      // Shopify predictive JSON uses a formatted product price string.
      const currency=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active;
      return (currency?currency+' ':'')+str;
    }
    function render(term,payload){
      popup.replaceChildren();
      const results=payload?.resources?.results||{};
      const queries=Array.isArray(results.queries)?results.queries:[];
      const products=Array.isArray(results.products)?results.products:[];
      if(queries.length){
        heading('Suggestions');
        queries.slice(0,5).forEach(q=>{
          const label=q.text||q.title;
          if(label)popup.appendChild(row(label,q.url||resultsUrl(label)));
        });
      }
      if(products.length){
        heading('Products');
        products.slice(0,6).forEach(p=>{
          const a=row('',p.url||resultsUrl(p.title||term));
          const img=imgFor(p);if(img)a.appendChild(img);
          const info=element('span','oleeya-predictive-product-text');
          info.appendChild(element('span','oleeya-predictive-product-title',p.title||'Product'));
          const price=priceFor(p);
          if(price)info.appendChild(element('span','oleeya-predictive-product-price',price));
          a.appendChild(info);popup.appendChild(a);
        });
      }
      if(!products.length&&!queries.length)
        popup.appendChild(element('div','oleeya-predictive-message','No matches yet. Try a different keyword.'));
      const all=element('a','oleeya-predictive-search-all','See all results for “'+term+'”');
      all.href=resultsUrl(term);popup.appendChild(all);show();
    }
    function renderError(term,status){
      popup.replaceChildren();
      const message=status===417?'Search suggestions are not available for this store language.':
        status===429?'Search suggestions are temporarily busy. Try again.':
        status===422?'Search suggestions returned an invalid-parameter error.':
        'Live suggestions could not load'+(status?' ('+status+')':'')+'.';
      popup.appendChild(element('div','oleeya-predictive-message',message));
      const all=element('a','oleeya-predictive-search-all','Search for “'+term+'”');
      all.href=resultsUrl(term);popup.appendChild(all);show();
    }
    function requestUrl(term,mode){
      const raw=area.dataset.oleeyaPredictiveUrl||'/search/suggest';
      const u=new URL(raw,location.origin);
      u.pathname=u.pathname.replace(/\.json$/,'').replace(/\/$/,'')+'.json';
      u.search='';
      u.searchParams.set('q',term);
      if(mode==='products')u.searchParams.set('resources[type]','product');
      return u.toString();
    }
    async function fetchResults(term,signal){
      let code=0;
      // First try the official default request, minimizing store-specific parameter issues.
      for(const mode of ['default','products']){
        const response=await fetch(requestUrl(term,mode),{
          credentials:'same-origin',signal,headers:{'Accept':'application/json'}
        });
        if(response.ok)return response.json();
        code=response.status;
        if(code===417||code===429)break;
      }
      const error=new Error('Predictive search HTTP '+code);
      error.status=code;throw error;
    }

    async function fallbackSearch(term,signal){
      // Shopify section rendering uses regular /search, which works even for buyer locale zh-CN.
      const u=new URL(form.action,location.origin);
      u.searchParams.set('q',term);
      u.searchParams.set('type','product');
      u.searchParams.set('section_id','oleeya-mobile-search-results');
      const response=await fetch(u.toString(),{signal,credentials:'same-origin',headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('Search section '+response.status);
      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const source=doc.querySelector('[data-oleeya-search-source]');
      if(!source)throw new Error('Search results section missing');
      const products=Array.from(source.querySelectorAll('[data-oleeya-search-product]')).map(e=>({
        title:e.getAttribute('data-title')||'',
        url:e.getAttribute('data-url')||'',
        price:e.getAttribute('data-price')||'',
        image:e.getAttribute('data-image')||'',
        type:e.getAttribute('data-type')||''
      }));
      popup.replaceChildren();
      const types=[...new Set(products.map(p=>p.type.trim()).filter(Boolean))].slice(0,4);
      if(types.length){
        heading('Suggestions');
        types.forEach(t=>popup.appendChild(row(t,resultsUrl(t))));
      }
      if(products.length){
        heading('Products');
        products.forEach(p=>{
          const a=row('',p.url||resultsUrl(p.title||term));
          if(p.image){
            const img=element('img','oleeya-predictive-product-img');
            img.src=p.image;img.alt='';img.loading='lazy';a.appendChild(img);
          }
          const details=element('span','oleeya-predictive-product-text');
          details.appendChild(element('span','oleeya-predictive-product-title',p.title));
          if(p.price)details.appendChild(element('span','oleeya-predictive-product-price',p.price));
          a.appendChild(details);popup.appendChild(a);
        });
      } else popup.appendChild(element('div','oleeya-predictive-message','No matching products. Try a different keyword.'));
      const all=element('a','oleeya-predictive-search-all','See all results for “'+term+'”');
      all.href=resultsUrl(term);popup.appendChild(all);show();
    }
    async function update(){
      const term=input.value.trim();const myId=++counter;
      if(active)active.abort();
      if(!term){popup.replaceChildren();hide();return;}
      if(!window.fetch||!window.AbortController){renderError(term,0);return;}
      active=new AbortController();
      try{
        const data=await fetchResults(term,active.signal);
        if(myId===counter&&input.value.trim()===term)render(term,data);
      }catch(err){
        if(err.name==='AbortError')return;
        if(myId!==counter||input.value.trim()!==term)return;
        try{
          await fallbackSearch(term,active.signal);
        }catch(fallbackError){
          if(fallbackError.name==='AbortError')return;
          if(myId===counter&&input.value.trim()===term)renderError(term,err.status||0);
        }
      }
    }
    input.addEventListener('input',()=>{
      clearTimeout(timer);
      if(!input.value.trim()){counter++;if(active)active.abort();popup.replaceChildren();hide();return;}
      timer=setTimeout(update,230);
    });
    input.addEventListener('focus',()=>{if(input.value.trim())update()});
    input.addEventListener('keydown',e=>{if(e.key==='Escape')hide()});
    document.addEventListener('pointerdown',e=>{if(!area.contains(e.target))hide()});
    form.addEventListener('submit',hide);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();